<!--
 * @Description: 支付详情页--暂时没有
 * @Date: 2020-12-11 14:59:17
-->
<template>
  <div></div>
</template>

<script>
export default {
  name: '',
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
